export default __webpack_public_path__ + "static/media/done.5844832f.svg";